import React, { useEffect } from 'react';

 type SnackbarType = 'success' | 'error' | 'warning' | 'info';

 interface SnackbarProps {
  message: string;
  type?: SnackbarType;
  duration?: number;
  isOpen: boolean;
  onClose: () => void;
}
const Snackbar: React.FC<SnackbarProps> = ({
  message,
  type = 'info',
  duration = 3000,
  isOpen,
  onClose,
}) => {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isOpen, duration, onClose]);

  if (!isOpen) return null;

  const getColorClasses = () => {
    switch (type) {
      case 'success':
        return 'bg-[#4CAF50] text-[#fff]';
      case 'error':
        return 'bg-[#F44336] text-[#fff]';
      case 'warning':
        return 'bg-[#2196F3] text-[#fff]';
      case 'info':
      default:
        return 'bg-blue-500 text-white';
    }
  };

  return (
   <div className="fixed bottom-4 left-1/2 md:left-[10%] transform -translate-x-1/2 md:translate-x-0 z-50">
     <div className={`${getColorClasses()} px-6 py-3 rounded-lg shadow-lg flex items-center min-w-[300px] max-w-[90vw]`}>
    <span>{message}</span>
    <button
      onClick={onClose}
      className="ml-4 text-white hover:text-gray-200 focus:outline-none"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
          clipRule="evenodd"
        />
      </svg>
    </button>
  </div>
</div>

  );
};

export default Snackbar;